"use strict";

exports.__esModule = true;
exports.default = void 0;

var _app = _interopRequireDefault(require("./app.m24"));

var _app2 = _interopRequireDefault(require("./app.dm"));

var _app3 = _interopRequireDefault(require("./app.kp"));

var _app4 = _interopRequireDefault(require("./app.kulturnav"));

var _app5 = _interopRequireDefault(require("./app.primus"));

var _app6 = _interopRequireDefault(require("./app.minner"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  uniqueId: 1,
  root: "/rock",
  name: "rock",
  title: "Rockheim",
  imageUrl: "https://dms-cf-09.dimu.org/image/032yiVGVkzHu",
  apps: [_app.default, _app2.default, _app3.default, _app5.default, _app4.default, _app6.default]
};
exports.default = _default;
module.exports = exports.default;